import React from 'react';

export function StepHeader({ step, title }: { step: number; title: string }) {
  return (
    <div className="mb-3 flex items-center gap-3">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ui-cta-primary text-body-sm font-bold text-white">
        {step}
      </span>
      <h3 className="text-body-md font-bold text-ui-text-primary-text">
        {title}
      </h3>
    </div>
  );
}
